import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getConnectorConfigurationsQueryKey } from "ConnectorConfigurations/Api/Queries/useConnectorConfigurationsQuery";
import {
	type UpdateConnectorConfigurationCommand,
	putConnectorConfiguration,
} from "Infrastructure/Api/Api";

export function useUpdateConnectorConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			id,
			command,
		}: { id: number; command: UpdateConnectorConfigurationCommand }) =>
			putConnectorConfiguration(id, command),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [getConnectorConfigurationsQueryKey(0, 100)],
			});
		},
	});
}
